const userDevice = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes('iphone')) {
    return 'iphone';
  }
  if (userAgent.includes('ipad')) {
    return 'ipad';
  }
  if (userAgent.includes('edg')) {
    return 'Edge';
  }
  if (
    userAgent.includes('chrome') &&
    !userAgent.includes('edge') &&
    !userAgent.includes('opr')
  ) {
    return 'Chrome';
  }

  if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
    return 'Safari';
  }

  return 'Other';
};

export default userDevice;
